import axios from 'axios';

export const ACCEPT_LEAD_REQUESTED = 'ACCEPT_LEAD_REQUESTED';
export const ACCEPT_LEAD_COMPLETE = 'ACCEPT_LEAD_COMPLETE';
export const ACCEPT_LEAD_FAILED = 'ACCEPT_LEAD_FAILED';

const acceptLead = lead => (
    (dispatch) => {
        dispatch({
            type: ACCEPT_LEAD_REQUESTED,
            lead,
        });

        return axios.post(
            `/api/leads/${lead.id}/accept`,
            {},
            {
                validateStatus: (s) => (s >= 200 && s < 300),
            }
        )
            .then((response) => {
                dispatch({
                    type: ACCEPT_LEAD_COMPLETE,
                    lead,
                });
                if (window !== window.parent && window.parent.hideInlineLead !== undefined) {
                    window.parent.hideInlineLead();
                    window.parent.location.reload();
                    return;
                }
                window.location = '/leads/available';
            })
            .catch((error) => {
                dispatch({
                    type: ACCEPT_LEAD_FAILED,
                    lead,
                    error,
                });
            });
    }
);

export default acceptLead;
